export const Charging = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 3H17L21 7V17L17 21H7L3 17V7L7 3Z" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path d="M12 17V20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const Style = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 1H16.5L19.5 4V20L16.5 23H8.5L5.5 20V4L8.5 1Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M13.5 9L11.3787 11.1213" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M13.6213 13L11.5 15.1213" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
);

export const Screen = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 1H16.5L19.5 4V20L16.5 23H8.5L5.5 20V4L8.5 1Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M10.5 7V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5 7V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
